export default __webpack_public_path__ + "0f73c88.png";